import "bootstrap-daterangepicker/daterangepicker.css"
import moment from "moment"
import React, { useEffect, useRef, useState } from "react"
import DateRangePicker from "react-bootstrap-daterangepicker"
import { Calendar4, ChevronDown } from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"
// import { RefObject } from "hoist-non-react-statics/node_modules/@types/react";

const DateRangePickerCustom = ({
    setStartDate,
    setEndDate,
    startDate,
    endDate
}: {
    setStartDate: Function
    setEndDate: Function
    startDate: string
    endDate: string
}) => {
    const { t } = useTranslation()
    const dateRangePickerRef = useRef(null) as any
    const [rangeStyle, setRangeStyle] = useState("custom-empty-date-range-picker")
    const [dateValue, setDateValue] = useState("")

    const focusOnDateRangePicker = () => {
        if (dateRangePickerRef) {
            dateRangePickerRef?.current?.ref.focus()
        }
    }

    const handleApply = (
        e: any,
        picker: {
            element: { val: (arg0: string) => void }
            startDate: { format: (arg0: string) => string }
            endDate: { format: (arg0: string) => string }
        }
    ) => {
        picker?.element?.val(
            picker.startDate.format("DD MMM YYYY") + " - " + picker.endDate.format("DD MMM YYYY")
        )
        setStartDate(picker.startDate)
        setEndDate(picker.endDate)
        setRangeStyle("custom-date-range-picker")
    }

    const handleCancel = (e: any, picker: { element: { val: (arg0: string) => void } }) => {
        setStartDate("2020-01-01")
        setEndDate(moment()?.format("YYYY-MM-DD"))
        picker?.element?.val("")
        setRangeStyle("custom-empty-date-range-picker")
    }

    useEffect(() => {
        setRangeStyle("custom-date-range-picker")
        if (startDate && endDate)
            setDateValue(
                moment(startDate).format("DD MMM YYYY") + " - " + moment(endDate).format("DD MMM YYYY")
            )
    }, [startDate, endDate])

    return (
        <div className={`d-flex align-items-center white-background p-2 px-3 h-100 ${rangeStyle}`}>
            <Calendar4 className="opacity-2 img-width" onClick={focusOnDateRangePicker} />
            <DateRangePicker
                ref={dateRangePickerRef}
                initialSettings={{
                    autoUpdateInput: false,
                    locale: {
                        cancelLabel: "Clear"
                    }
                }}
                onApply={handleApply}
                onCancel={handleCancel}>
                <input
                    type="text"
                    className="mr-2 ml-2 text-center"
                    placeholder={t("Date")}
                    value={dateValue}
                />
            </DateRangePicker>
            <ChevronDown className="img-width" onClick={focusOnDateRangePicker} />
        </div>
    )
}

export default DateRangePickerCustom
